import React, { useContext, useEffect, useState } from "react";
import {
  empType,
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders
} from "../../../../../utils/Enum.types";
import { Title } from "../../../../../stories/Title/Title";
import Input from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../utils/types";
import {
  GridAlignment,
  GridColDef,
  GridValidRowModel
} from "@mui/x-data-grid-pro";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import {
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  TABLE_ROW_HEIGHT
} from "../../../../../styles/Variables";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import { useNavigate } from "react-router-dom";
import NoData from "../../../../../images/NoData.svg";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import {
  AddModalStyles,
  CustomModalStyles,
  EditModalStyles,
  ViewModalStyles
} from "../../../../../styles/CustomModalStyles";
import EditModal from "./edit/Index";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import {
  AtsSubsidiaryEdge,
  AtsSubsidiaryOrderField,
  DeleteSubsidiaryByIdResult,
  DeleteSubsidiaryByIdVars,
  GetSubsidiariesResult,
  GetSubsidiariesVars
} from "./queries/types";
import { modalOpertaionFlag } from "../../../customer/Index";
import { GetSubsidiaries } from "./queries/queries";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CustomModal,
  getModifiedScrollHeight
} from "../../../../../utils/UtilFunctions";
import {
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage
} from "../../../../../utils/constants";

import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { DeleteSubsidiary } from "./queries/mutations";
import LoadingModal from "../../../../pages/LoadingModal";
import Modal from "react-modal";
import List from "./assetsite/List";
import Navbar from "../../../../common/layout/Navbar";
import ItemsDetailsImport from "../../item/ImportItemsDetails";
import ImportSubsidiary from "./ImportSubsidiary";
import { useHotKey } from "../../../../../utils/hotKeys";
import { SpecialKeys } from "../../../../../utils/Enum.keys";
import useLabels from "../../../../../customHooks/useLabels";
import SubsidiaryAdd from "./add/CompanyDetails";
import useCompanyConfiguration from "../../../../../customHooks/useCompanyConfiguration";
import {
  GetNotAllocatedIdsResult,
  GetNotAllocatedIdsVar,
  TableType
} from "../../../customer/companies/queries/types";
import { GetNotAllocatedIds } from "../../../customer/companies/queries/queries";

const SubsidiaryIndex = () => {
  const { Masters_Table } = useAssetTableJson();
  const navigate = useNavigate();
  const { state, dispatch } = useContext(AppContext);
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [importSubsidiaryModal, setImportSubsidiaryModal] = useState(false);

  const { customer_id, company_id } = useUrlParams();
  const { USE_ENABLE_SUBSIDIARY_SITE, USE_ENABLE_JUNCTION } =
    useCompanyConfiguration();



  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [subsidiries, setSubsidiries] = useState<AtsSubsidiaryEdge[]>([]);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [addModal, setAddModal] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [message, setMessage] = useState(emptyMessage);
  const { user_details } = useLoggedInUserDetails();
  const { subsidiaryLabel } = useLabels();
  const [editModal, setEditModal] = useState(false);
  const dynamicHeaders: TableHeaderProps[] = Masters_Table.Subsidary.map(
    (header) => ({
      headerName: header.headerName,
      cellClassName: header.cellClassName as string,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex as number,
      hideable: header.hideable
    })
  );
  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      field: "actions",
      cellClassName: "td-status ",
      headerAlign: HEADER_TEXT_ALIGN,
      align: MARKS_TEXT_ALIGN,
      headerName: TableHeaders.ACTION,
      renderCell: (params) => {
        return (
          <>
            <img
              src={Edit}
              alt=""
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_SUB_ID,
                  payload: {
                    subsidiaryId: params.row.subId
                  }
                });
                setEditModal(true);
              }}
            />
            <img
              src={Delete}
              alt="/"
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_SUB_ID,
                  payload: {
                    subsidiaryId: params.row.subId
                  }
                });
                setDeleteModal(!deleteModal);
              }}
            />
          </>
        );
      }
    }
  ];

  const [getNotAllocatedIds] = useLazyQuery<
    GetNotAllocatedIdsResult,
    GetNotAllocatedIdsVar
  >(GetNotAllocatedIds);

  const [GetSubsidiary, { data, loading, fetchMore }] = useLazyQuery<
    GetSubsidiariesResult,
    GetSubsidiariesVars
  >(GetSubsidiaries);

  const [DeleteSelectedSubsidiary, { loading: deletionLoading }] = useMutation<
    DeleteSubsidiaryByIdResult,
    DeleteSubsidiaryByIdVars
  >(DeleteSubsidiary, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE
      });
    }
  });

  const HandleDelete = async () => {
    setDeleteModal(!deleteModal);
    DeleteSelectedSubsidiary({
      variables: {
     
        subsidiaryID: state.subsidiaryId,
        user_details
      },
      refetchQueries: [
        {
          query: GetSubsidiaries,
          variables: {
            after: null,
            customerID: customer_id,
            companyID: company_id,
            empID: user_details.id,
            first: ROWS_PER_PAGE,
            orderBy: {
              direction: OrderDirection.ASC,
              field: AtsSubsidiaryOrderField.NAME
            },
         
            name: searchData
          }
        }
      ]
    }).then(({ data }) => {
      if (data) {
        setMessage({
          flag: true,
          message: `${subsidiaryLabel} Deleted Sucessfully`,
          operation: Operation.DELETE
        });
      }
    });
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetSubsidiaries.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = subsidiries.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node
              }
            };
          }
          return newCompany;
        });
        setSubsidiries(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            company_name: node.name,
            company_addr: node.address,
            company_email: node.email,
            company_mobile: node.mobile,
            company_c_person: node.contactPerson,
            subId: node.id,
            companyID: node.companyID,
            customerID: node.customerID
          }))
        );
      } else {
        setSubsidiries(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            company_name: node.name,
            company_addr: node.address,
            company_email: node.email,
            company_mobile: node.mobile,
            company_c_person: node.contactPerson,
            subId: node.id,
            companyID: node.companyID,
            customerID: node.customerID
          }))
        );
      }
      setEndCursor(data.GetSubsidiaries.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetSubsidiaries.edges;
              const pageInfo = fetchMoreResult.GetSubsidiaries.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetSubsidiaries.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetSubsidiaries: {
                  edges: [...subsidiries, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetSubsidiaries.totalCount! : 0
                }
              };
            }
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    GetSubsidiary({
      variables: {
        after: null,
        customerID: customer_id ? customer_id : 0,
        companyID: company_id ? company_id : 0,
        empID: user_details.id,
        first: ROWS_PER_PAGE,
        orderBy: {
          direction: OrderDirection.ASC,
          field: AtsSubsidiaryOrderField.NAME
        },
     
        name: searchData
      }
    });
  }, [customer_id, company_id, user_details.id, GetSubsidiary, searchData]);

  useHotKey({
    handleFunc: () => {
      if (state.empSubType === empType.SYS_ADMIN)
        navigate(`/${customer_id}/company/${company_id}/subsidary/add`);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a"
  });

  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <Title>{subsidiaryLabel}</Title>
      <div className="subsidary">
        <div className="row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              onChange={(e) => setSearchData(e.target.value)}
              placeholder="Search..."
            />
          </div>
          <div className="col flex-end">
            {state.empSubType === empType.SYS_ADMIN ? (
              <Button
                mode="addnew"
                onClick={() => {
                  setAddModal(true);
                }}
              />
            ) : null}
          </div>
        </div>
        <div className="subsidary__tableblock">
          {rows.length ? (
            <StyledDatagrid
              columns={
                state.empSubType === empType.SYS_ADMIN
                  ? columns
                  : dynamicHeaders
              }
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              onCellClick={async (params) => {
                if (params.field === "company_name") {
                  if (USE_ENABLE_SUBSIDIARY_SITE) {
                    navigate(
                      `/${params.row.customerID}/company/${params.row.companyID}/subsidiary/${params.row.subId}/assetsite`
                    );
                  } else if (USE_ENABLE_JUNCTION) {
              
                    if (
                      
                      params.row.customerID &&
                      params.row.companyID
                    ) {
                      const result = await getNotAllocatedIds({
                        variables: {
                          companyID: params.row.companyID,
                          customerID: params.row.customerID,
                          table: TableType.SUBSIDIARY,
                          table_id: params.row.subId,
                          
                        }
                      });

                      if (
                        result.data &&
                        result.data.GetNotAllocatedIds.siteID
                      ) {
                        navigate(
                          `/${params.row.customerID}/company/${params.row.companyID}/subsidiary/${params.row.subId}/site/${result.data.GetNotAllocatedIds.siteID}/junctions`
                        );
                      }
                    }
                  }
                }
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>
        <div className="row">
          <div className="col-10">
            {state.empSubType === empType.SYS_ADMIN ? (
              <Button
                mode="excel"
                type="button"
                onClick={() => setImportSubsidiaryModal(true)}
              >
                Import {subsidiaryLabel}
              </Button>
            ) : null}
            <Button mode="back" onClick={() => navigate(-1)} />
          </div>
          <div className="col  flex-end">
            <div className="overall-total-count">
              Total Count : <b>{data?.GetSubsidiaries.totalCount}</b>
            </div>
          </div>
        </div>
      </div>
      <DeleteModal
        id={state.subsidiaryId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={HandleDelete}
      />

      <CustomModal
        isOpen={editModal}
        onRequestClose={() => setEditModal(!editModal)}
        contentComponent={
          <SubsidiaryAdd
            setModalFlag={setEditModal}
            operation={Operation.UPDATE}
          />
        }
        style={CustomModalStyles}
      />

      <CustomModal
        isOpen={addModal}
        onRequestClose={() => setAddModal(!addModal)}
        contentComponent={
          <SubsidiaryAdd
            setModalFlag={setAddModal}
            operation={Operation.CREATE}
          />
        }
        style={CustomModalStyles}
      />

      <CustomModal
        isOpen={importSubsidiaryModal}
        onRequestClose={() => setImportSubsidiaryModal(!importSubsidiaryModal)}
        contentComponent={
          <ImportSubsidiary
            setModalFlag={setImportSubsidiaryModal}
            pageType={PageFor.MODAL}
            NavType={LicenseTypes.COMPANY}
          />
        }
        style={AddModalStyles}
      />
      <LoadingModal flag={(!searchData && loading) || deletionLoading} />
    </>
  );
};

export default SubsidiaryIndex;
